/** Session storage functionality  **/
const sessionCookieHelper = {

	set_cookie: function(name, value){
		sessionStorage[name] = value;
	},

	get_cookie: function(name){
		let readValue = sessionStorage[name];
		if (readValue){
		    return readValue;
		}
		else{
		    return false;
		}
	}

}

export { sessionCookieHelper }